import { createPinia } from "pinia"
import {useUserTokenStore} from "./usertoken";

const pinia = createPinia(useUserTokenStore);

export default pinia;
